import { Link } from 'react-router-dom';
import '../styles/components/CtaSection.css';

export default function CtaSection() {
  return (
    <section className="cta">
      <h2>Spremni za sledeći korak?</h2>
      <p>Zakažite konsultacije već danas.</p>
      <Link to="/kontakt" className="cta-button">
        Kontaktirajte nas
      </Link>
    </section>
  );
}
